import { render, staticRenderFns } from "./organization-unit-form.vue?vue&type=template&id=58b0ce03"
import script from "./organization-unit-form.vue?vue&type=script&lang=js"
export * from "./organization-unit-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports